module.exports = __webpack_public_path__ + "fonts/Merriweather-500-latin21.5c271de.woff2";